import Modal from '../../../../components/common/ui/Modal';
import Button from '../../../../components/common/ui/Button';

import styles from './styles.module.scss';

const ActivationPaymentsModal = ({ isOpen, toggleModal }) => {
  return (
    <Modal
      className={styles.activationPaymentsModal}
      isOpen={isOpen}
      onClose={toggleModal}
      hideCloseIcon={true}
    >
      <h3>Check your inbox!</h3>
      <p>
        Email with instructions on how to update your payment method was sent to
        the email address you used when you registered or purchased the device.
      </p>
      <Button
        className={styles.activationPaymentsModalButton}
        onClick={toggleModal}
      >
        Got It
      </Button>
    </Modal>
  );
};
export default ActivationPaymentsModal;
